<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells_hd">基础信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <qcc-search-box :label="customLabel.ve_name || '供应商名称'" slot="ve_name" placeholder="请输入供应商名称" v-model="form.main.ve_name" 
              @select="onQccSelect($event)" @change="vendChange"></qcc-search-box>
        <div class="weui-cell" slot="ve_nsrzh">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_nsrzh || "社会信用代码"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.ve_nsrzh" placeholder="请填写" />
          </div>
        </div>
        <combo-field
          slot="ve_type"
          :label="customLabel.ve_type || '供应商类型'"
          v-model="form.main.ve_type"
          url="/api/document/vendorkind/getCombo"
        />
        <div class="weui-cell" slot="ve_address">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_address || "公司地址"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.ve_address" placeholder="请填写" />
          </div>
        </div>
      </custom-layout>

      <div class="weui-cells_hd">交易信息</div>
      <custom-layout class="weui-cells" :view-config="customViewConfig">
        <currency-field slot="ve_currency" :label="customLabel.ve_currency || '默认币种'"  v-model="form.main.ve_currency" :use-default="true" />
        <div class="weui-cell" slot="ve_taxrate">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_taxrate || "税率(%)"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="number"
              v-model="form.main.ve_taxrate"
              placeholder="请填写"
            />
          </div>
        </div>
        <div class="weui-cell" slot="ve_bankcode">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_bankcode || "开户银行"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input class="weui-input" type="text" v-model="form.main.ve_bankcode" placeholder="请填写" />
          </div>
        </div>
        <div class="weui-cell" slot="ve_bankaccount">
          <div class="weui-cell__hd">
            <label for class="weui-label">{{customLabel.ve_bankaccount || "银行账号"}}</label>
          </div>
          <div class="weui-cell__bd">
            <input
              class="weui-input"
              type="text"
              v-model="form.main.ve_bankaccount"
              placeholder="请填写"
            />
          </div>
        </div>
        <payment-field slot="ve_payments" :label="customLabel.ve_payments || '付款方式1'" :is-rec="false" v-model="form.main.ve_payments" @select="onSelectPayment($event,0)" />
        <payment-field slot="ve_payments1" :label="customLabel.ve_payments1 || '付款方式2'" :is-rec="false" v-model="form.main.ve_payments1" @select="onSelectPayment($event,1)" />
        <payment-field slot="ve_payments2" :label="customLabel.ve_payments2 || '付款方式3'" :is-rec="false" v-model="form.main.ve_payments2" @select="onSelectPayment($event,2)" />
        <employee-field slot="ve_buyername" :label="customLabel.ve_buyername || '采购员 '" v-model="form.main.ve_buyername" @select="onSelectEmployee" />
        <department-field 
          slot="ve_dpname" 
          :label="customLabel.ve_dpname || '事业部门'" 
          v-model="form.main.ve_dpname" 
          @select="onSelectDepartment" />
        <custom-field 
          :label="customLabel.ve_text1 || '自定义字段1'"
          v-model="form.main.ve_text1" :caller="caller" fieldName="ve_text1"
          slot="ve_text1" hidden="true"
        />
        <custom-field
          :label="customLabel.ve_text2 || '自定义字段2'"
          v-model="form.main.ve_text2" :caller="caller" fieldName="ve_text2"
          slot="ve_text2" hidden="true"
        />
        <custom-field 
          :label="customLabel.ve_text3 || '自定义字段3'"
          v-model="form.main.ve_text3" :caller="caller" fieldName="ve_text3"
          slot="ve_text3" hidden="true"
        />
        <custom-field 
          :label="customLabel.ve_text4 || '自定义字段4'"
          v-model="form.main.ve_text4" :caller="caller" fieldName="ve_text4"
          slot="ve_text4" hidden="true"
        />
        <custom-field 
          :label="customLabel.ve_text5 || '自定义字段5'"
          v-model="form.main.ve_text5" :caller="caller" fieldName="ve_text5"
          slot="ve_text5" hidden="true"
        />
       
      </custom-layout>

      <div class="weui-cells__group" v-for="(item,xindex) in form.items" :key="xindex">
        <div class="weui-cells__title">
          <span>联系人{{xindex+1}}</span>
          <a href="javascript:;" class="header-tool" @click="removeItem(xindex)">
            <span>删除</span>
          </a>
        </div>
        <custom-layout class="weui-cells"  :view-config="customViewConfig" position="detail1">
          <div class="weui-cell" slot="vc_name">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.vc_name || "联系人"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="item.vc_name" placeholder="请填写" />
            </div>
          </div>
          <div class="weui-cell" slot="vc_tel">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.vc_tel || "电话"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="item.vc_tel" placeholder="请填写" />
            </div>
          </div>
          <div class="weui-cell" slot="vc_email">
            <div class="weui-cell__hd">
              <label for class="weui-label">{{customLabel.vc_email || "邮箱"}}</label>
            </div>
            <div class="weui-cell__bd">
              <input class="weui-input" type="text" v-model="item.vc_email" placeholder="请填写" />
            </div>
          </div>
          <div class="weui-cell weui-cell_active weui-cell_switch" slot="vc_default">
            <div class="weui-cell__bd">{{customLabel.vc_default || "默认联系人"}}</div>
            <div class="weui-cell__ft">
              <input
                class="weui-switch"
                v-model="item.vc_default"
                type="checkbox"
                v-bind:true-value="1"
                v-bind:false-value="0"
                @change="onChangeDefault(item,xindex)"
              />
            </div>
          </div>
          <custom-field 
            :label="customLabel.vc_text1 || '自定义字段1'"
            v-model="item.vc_text1" :caller="caller" fieldName="vc_text1"
            slot="vc_text1" hidden="true"
          />
          <custom-field
            :label="customLabel.vc_text2 || '自定义字段2'"
            v-model="item.vc_text2" :caller="caller" fieldName="vc_text2"
            slot="vc_text2" hidden="true"
          />
          <custom-field 
            :label="customLabel.vc_text3 || '自定义字段3'"
            v-model="item.vc_text3" :caller="caller" fieldName="vc_text3"
            slot="vc_text3" hidden="true"
          />
          <custom-field 
            :label="customLabel.vc_text4 || '自定义字段4'"
            v-model="item.vc_text4" :caller="caller" fieldName="vc_text4"
            slot="vc_text4" hidden="true"
          />
          <custom-field 
            :label="customLabel.vc_text5 || '自定义字段5'"
            v-model="item.vc_text5" :caller="caller" fieldName="vc_text5"
            slot="vc_text5" hidden="true"
          />
        </custom-layout>
        <a
            href="javascript:"
            v-if="xindex==form.items.length-1"
            class="weui-cell weui-cell_link"
            @click="addItem"
          >
            <div class="weui-cell__bd">添加更多</div>
          </a>
      </div>
      <div class="weui-cells">
        <file-field v-model="form.main.ve_attach" ref="ve_attach" />
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import ComboField from "@/components/field/ComboField.vue";
import FileField from "@/components/field/FileField.vue";
import CurrencyField from "@/components/field/CurrencyField.vue";
import PaymentField from "@/components/field/PaymentField.vue";
import EmployeeField from "@/components/field/EmployeeField.vue";
import DepartmentField from "@/components/field/DepartmentField.vue";
import QccSearchBox from "@/components/field/QccSearchBox";
import process from "@/mixins/process.js";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [process],
  components: {
    CustomLayout,
    ComboField,
    FileField,
    CurrencyField,
    PaymentField,
    EmployeeField,
    DepartmentField,
    QccSearchBox,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/document/vendor",
      codeField: "ve_code",
      statusField: "ve_audit_status_code",
      caller: "Vendor",
      xtype: "document-vendor-formpanel",
      form: {
        main: {
          ve_taxrate: 0,
          ve_dpname: null
        },
        items: [
          {
            vc_default: 1
          }
        ]
      }
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main,
        items = me.form.items;
      if (!main.ve_name) {
        me.$weui.topTips("请填写供应商名称", 2000);
      } else if (!main.ve_currency) {
        me.$weui.topTips("请选择默认币种", 2000);
      } else if (!main.ve_payments) {
        me.$weui.topTips("请选择付款方式", 2000);
      } else {
        var count = 0;
        items.forEach(function(item) {
          if (!item.vc_name) {
            me.$weui.topTips(`第${count + 1}行未填写联系人`, 2000);
            return false;
          } else {
            count++;
            item.vc_detno = count;
          }
        });
        if (count == items.length) {
          me.p_save();
        }
      }
    },
    onSelectPayment(selection, index) {
      var me = this,
        main = me.form.main;
      main['ve_paymentsid' + (index ? index : '')] = selection.id;
      main['ve_paymentscode' + (index ? index : '')] = selection.pa_code;
    },
    onSelectEmployee(selection) {
      var me = this,
        main = me.form.main;
      main.ve_buyerid = selection.id;
      main.ve_buyercode = selection.em_code;
      main.ve_dpid = selection.em_dpid;
      main.ve_dpcode = selection.dp_code;
      main.ve_dpname = selection.dp_name;
    },
    onSelectDepartment(selection) {
      var me = this,
        main = me.form.main;
      main.ve_dpid = selection.id;
      main.ve_dpcode = selection.dp_code;
      main.ve_dpname = selection.dp_name;
    },
    /**
     * 删除行
     */
    removeItem(index) {
      var me = this,
        items = me.form.items;
      if (items.length == 1) {
        me.$weui.topTips("请至少保留一行", 2000);
      } else {
        items.splice(index, 1);
      }
    },
    /**
     * 新增行
     */
    addItem() {
      var me = this,
        items = me.form.items;
      items.push({
        vc_default: 0
      });
    },
    onChangeDefault(item, index) {
      if (item.vc_default) {
        var me = this,
          items = me.form.items;
        for (var i = 0, len = items.length; i < len; i++) {
          if (i != index) {
            items[i].vc_default = 0;
          }
        }
      }
    },
    /**
     * 企查查模糊查询选择
     */
    onQccSelect(company) {
      var code = company.creditCode;
      if (!code || !code.length) {
        code = company.no;
      }
      this.form.main.ve_nsrzh = code;
      this.form.main.ve_legal_person = company.operName;
    },
    vendChange() {
      this.form.main.ve_nsrzh = null
    }
  }
};
</script>